import store from '@/store'

const nextStepper = (state, payload) => {
    state.stepper_value = payload
}
const backStepper = (state, payload) => {
    state.stepper_value = payload
}

const setIdProyecto = (state, id_proyecto) => {
    state.form_proyecto.id.value = id_proyecto
}

const setProyectoNombre = (state, value) => {
    state.form_proyecto.nombre_proyecto.value = value
}

const setFotoDui = (state, value) => {
    state.form_proyecto.foto_dui.value = value
}

const setArchivoDUI = (state, value) => {
    state.archivoDUI = value
}

const setDuiDoc = (state, value) => {
    state.form_proyecto.dui_doc.value = value
}

const setAlcaldiaProyecto = (state, value) => {
    state.form_proyecto.institucion.value = value
}

const setNameInstitucion=(state,tipo_institucion)=>{
    state.form_proyecto.name_institucion.value=tipo_institucion
}

const setTipoProyecto = (state, value) => {
    state.form_proyecto.tipo_proyecto.value = value
}

const setDireccionProyecto = (state, value) => {
    state.form_proyecto.direccion_extra.value = value
}

const setTenenciaTierraProyecto = (state, value) => {
    state.form_proyecto.tenencia_tierra.value = value
}
const setIdProcessMethod = (state, value) => {
    state.form_proyecto.idProccessMethod.value = value
}

const setIdProcessMethodType= (state, value) => {
    state.form_proyecto.idProccessMethodType.value = value
}

const setDuiResponsableProyecto = (state, value) => {
    state.form_proyecto.dui_responsable.value = value
}

const setIdNombreResponsable = (state, payload) => {
    state.form_proyecto.id_responsable.value = payload.id_responsable
    state.form_proyecto.nombre_responsable.value = payload.nombre_responsable
}

const setDepartamento=(state,id_departamento)=>{
    state.form_proyecto.departamento.value=id_departamento
}

const setTipoInstitucion=(state,tipo_institucion)=>{
    state.form_proyecto.tipo_institucion.value=tipo_institucion
}

const setCorreoResponsable = (state, correo) => {
    state.form_proyecto.correo_electronico.contacto = correo
}

const setIdAndContactCorreoResponsable = (state, payload) => {
    state.form_proyecto.correo_electronico.contacto = payload.contacto
    state.form_proyecto.correo_electronico.id_contacto = payload.id
}

const setPlazoEstimacion = (state, value) => {
    state.form_proyecto.plazo_estimacion.value = value
}

const setProjectRequest = (state, value) => {
    state.form_proyecto.id_project_request.value = value
}

const addCarpetaFile = (state, payload) => {
    state.carpeta_items[payload.index].archivo.push(payload.value)
}
const setCarpetaFile = (state, payload) => {
    state.carpeta_items[payload.index].archivo = payload.value
}

const addLalLng = (state, payload) => {
    state.form_proyecto.lat_lng.value.push(payload)
}

const limpiarLatLng = (state) => {
    state.form_proyecto.lat_lng.value = []
}

const setFormProyectoMessage = (state, payload) => {
    state.form_proyecto[payload.propiedad].message = payload.value
}

const setFormProyectoState = (state, payload) => {
    state.form_proyecto[payload.propiedad].state = payload.value
}
const setFormProyectoValue = (value, payload) => {
    value.form_proyecto[payload.propiedad].value = payload.value
}
const setFormProyectoRequired = (required, payload) => {
    required.form_proyecto[payload.propiedad].required = payload.value
}

const setShowCreatePerson = (state, payload) => {
    state.showCreatePerson = payload
}

const setearLatLng = (state, payload) => {
    state.form_proyecto.lat_lng.value = payload
}

const limpiarArchivoDocumento = (state, id) => {
    state.carpeta_items.forEach(item => {
        if (item.id === id) item.archivo = null
    })
}

const limpiarProyectoState = (state) => {

    state.desembolsos = []
    state.carpeta_items = []
    state.observaciones_carpeta = []
    state.proyecto_data = {
        institucion: {},
        alcalde: {},
        responsable: {},
        plazo_estimacion: {},
        poligono: [],
        tecnico_asignado: {}
    }
    state.presupuestos = []
    state.actividades = []
    state.stepper_value = 1
    Object.keys(state.form_proyecto).forEach(propiedad => {
        if (propiedad !== 'correo_electronico') {
            if (propiedad === 'lat_lng')
                state.form_proyecto[propiedad].value = []
            else {
                state.form_proyecto[propiedad].value = null
                state.form_proyecto[propiedad].state = null
            }
        } else {
            state.form_proyecto[propiedad].contacto = null
            state.form_proyecto[propiedad].state = null
        }
    })

    Object.keys(state.actividad).forEach(propiedad => {
        state.actividad[propiedad].value = null
    })

    state.carpeta_items.forEach(item => {
        item.archivo = null
    })
}

const setearDesembolsos = (state, desembolsos) => {
    state.desembolsos = desembolsos
}

const setCostoTotalPresupuestado = (state, costo_total) => {
    state.form_proyecto.costo_total_presupado.value = costo_total
}

const setCarpetaItems = (state, payload) => {
    state.carpeta_items = payload
}

const setPorcentaje = (state, payload) => {
    if (state.desembolsos[payload.index].editable) {
        state.desembolsos[payload.index].porcentaje = Number(payload.porcentaje)
    } else
        store.dispatch('utils/temporalAlert', {
            show: true,
            message: 'No se puede cambiar porcentaje fijo',
            type: 'warning'
        })
}

const setPlazos = (state, plazos) => {
    state.plazos = plazos
}

const setIdEstado = (state, id_estado) => {
    state.form_proyecto.id_estado.value = id_estado
}

const setIdVerificationReception = (state, id_verification_reception) => {
    state.form_proyecto.id_verification_reception.value = id_verification_reception
}

const setIdVerificationCost = (state, id_verification_cost) => {
    state.form_proyecto.id_verification_cost.value = id_verification_cost
}

const setActivities = (state, actividades) => {
    state.actividades = actividades
}


const addActivity = (state, actividad) => {
    state.actividades.push(actividad)
}

const removeActivity = (state, indexActivity) => {
    state.actividades.splice(indexActivity, 1)
}

const setActivity = (state, payload) => {
    state.actividades[payload.index] = payload.actividad
}

const setActivityState = (state, payload) => {
    state.actividad[payload.propiedad].state = payload.value
}

const editActivity = (state, activity) => {
    state.actividad.index.value = activity.index
    state.actividad.id.value = activity.id
    state.actividad.actividad.value = activity.id_actividad
    state.actividad.cantidad.value = activity.cantidad
    state.actividad.precio_unitario.value = activity.precio_unitario
    state.archivo.value = activity.archivo
}

const setFormCantidadActivity = (state, cantidad) => {
    state.actividad.cantidad.value = cantidad
}

const setFormActivityActividad = (state, id_actividad) => {
    state.actividad.actividad.value = id_actividad
}

const setFormPrecioUnitarioActivity = (state, precio_unitario) => {
    state.actividad.precio_unitario.value = precio_unitario
}
const setFormArchivoActivity = (state, precio_unitario) => {
    state.archivo.value = precio_unitario
}

const setProyectoData = (state, data_proyecto) => {
    state.proyecto_data = data_proyecto
}

const setObservacionesByProyect = (state, observaciones) => {
    state.observaciones_carpeta = observaciones
}

const setCategoriasAceptadas = (state, categorias) => {
    state.categorias_aceptadas = categorias
}

const setTecnico=(state, id_tecnico)=>{
    state.proyecto_data.tecnico_asignado.id=id_tecnico
}

export {
    nextStepper,
    backStepper,
    setProyectoNombre,
    setFotoDui,
    setArchivoDUI,
    setDuiDoc,
    setAlcaldiaProyecto,
    setNameInstitucion,
    setTipoProyecto,
    setDireccionProyecto,
    setTenenciaTierraProyecto,
    setDuiResponsableProyecto,
    setPlazoEstimacion,
    addCarpetaFile,
    setCarpetaFile,
    addLalLng,
    limpiarLatLng,
    setFormProyectoMessage,
    setFormProyectoState,
    setFormProyectoValue,
    setFormProyectoRequired,
    setIdNombreResponsable,
    setShowCreatePerson,
    setIdProyecto,
    setearLatLng,
    limpiarArchivoDocumento,
    limpiarProyectoState,
    setCostoTotalPresupuestado,
    setCarpetaItems,
    setPorcentaje,
    setearDesembolsos,
    setPlazos,
    setIdEstado,
    setIdVerificationReception,
    setIdVerificationCost,
    setActivities,
    setActivity,
    removeActivity,
    addActivity,
    editActivity,
    setFormActivityActividad,
    setFormCantidadActivity,
    setFormPrecioUnitarioActivity,
    setIdAndContactCorreoResponsable,
    setCorreoResponsable,
    setProyectoData,
    setObservacionesByProyect,
    setCategoriasAceptadas,
    setActivityState,
    setDepartamento,
    setTipoInstitucion,
    setFormArchivoActivity,
    setTecnico,
    setProjectRequest,
    setIdProcessMethod,
    setIdProcessMethodType
}
